<template>
  <div class="wallet">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col
            class="col-md-10 d-flex align-center"
          >
            <v-icon
              left
              size="22"
            >
              {{ icons.mdiWallet }}
            </v-icon>
            Wallet Balance: <strong class="ml-2">Ksh {{ balance | formatCurrencyWithDecimal }}</strong>
          </v-col>
          <v-col class="col-md-2">
            <refresh-button
              :loading="isWalletBalanceRefreshing"
              @click="getBalance()"
            />
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>

    <withdrawal-form
      ref="withdrawalForm"
      :wallet-balance="balance"
      :destination="destination"
      :destination-type="destinationType"
      @balanceUpdated="onWithdrawalRequested"
    />

    <withdrawal-history-table ref="withdrawalHistoryTable" />
  </div>
</template>

<script>
import { mdiWallet } from '@mdi/js'
import axios from 'axios'
import RefreshButton from '@/components/partials/RefreshButton.vue'
import WithdrawalHistoryTable from '@/components/tables/WithdrawalHistoryTable.vue'
import WithdrawalForm from '@/components/partials/WithdrawalForm.vue'

export default {
  components: {
    RefreshButton,
    WithdrawalHistoryTable,
    WithdrawalForm,
  },
  data() {
    return {
      balance: '0.00',
      destination: null,
      destinationType: null,
      isWalletBalanceRefreshing: false,
      icons: {
        mdiWallet,
      },
    }
  },
  mounted() {
    this.getBalance()
    this.getWithdrawalDestination()
  },
  methods: {
    getBalance() {
      this.isWalletBalanceRefreshing = true
      axios
        .get('wallet/balance')
        .then(response => {
          this.balance = response.data.balance
        })
        .catch(error => {
          this.$notification.error(error.response?.data?.message || 'Could not load the wallet balance')
        })
        .finally(() => {
          this.isWalletBalanceRefreshing = false
        })
    },
    getWithdrawalDestination() {
      axios
        .get('settings')
        .then(response => {
          response.data.settings.forEach(setting => {
            if (setting.key === 'withdraw_to') {
              this.destinationType = setting.value
            }
            if (setting.key === 'withdraw_to_value') {
              this.destination = setting.value
            }
          })
        })
        .catch(error => {
          this.$notification.error(error.response?.data?.message || 'Could not load the withdrawal destination')
        })
    },
    onWithdrawalRequested() {
      // M-Pesa confirms the payout through a callback, so the balance only
      // changes a moment after the request is accepted.
      setTimeout(() => {
        this.getBalance()
        this.$refs.withdrawalHistoryTable.$emit('refresh-table')
      }, 2000)
    },
  },
}
</script>
